import React from 'react';
import { ButtonV2 as Button } from '@zola/zola-ui/src/components/Button';

import { Modal, ModalTitle, MobileFeatures } from './PlaceCardOnMobileModal.styles';
import placeCardIcon from './PlaceCardModalIcon.png';
import { PlaceCardMobileFeature } from './PlaceCardMobileFeature';

interface PlaceCardOnMobileModalProps {
  hideModalFn: () => void;
}

export const PlaceCardOnMobileModal: React.FC<PlaceCardOnMobileModalProps> = ({ hideModalFn }) => {
  const features = [
    'Import names from your contacts',
    'Preview your design live',
    'Customize fonts',
    'Link your Zola guest list',
    'Order a proof before committing',
  ];
  const appDownloadDeeplink = 'https://zola.app.link/ZvkYimnBmdb';

  return (
    <Modal>
      <div className="modal-header">
        <img alt="place card icon" src={placeCardIcon} />
        <ModalTitle className="modal-title">Continue On Our App</ModalTitle>
      </div>
      <div className="modal-body">
        Manage more features of your place card.
        <MobileFeatures>
          {features.map((feature, index) => (
            <PlaceCardMobileFeature key={index} feature={feature} />
          ))}
        </MobileFeatures>
      </div>
      <div className="modal-footer">
        <Button component="a" href={appDownloadDeeplink} onClick={hideModalFn} fullWidth>
          Edit On The App
        </Button>
      </div>
    </Modal>
  );
};

export default PlaceCardOnMobileModal;
